import { useState, useMemo } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useRequireRole } from "@/lib/use-require-role";
import { PageHeader } from "@/components/page-header";
import { Input } from "@/components/ui/input";
import { auditEvents, organizations } from "@/mocks/saas-data";

export const Route = createFileRoute("/admin/audit")({
  ssr: false,
  head: () => ({ meta: [{ title: "Admin — Audit Log" }] }),
  component: Page,
});

function Page() {
  const user = useRequireRole(["superadmin"]);
  const [q, setQ] = useState("");
  const filtered = useMemo(
    () => auditEvents.filter((e) => `${e.action} ${e.actor} ${e.target}`.toLowerCase().includes(q.toLowerCase())),
    [q],
  );
  if (!user) return null;
  return (
    <div className="mx-auto max-w-6xl px-6 py-8 lg:px-10 lg:py-10">
      <PageHeader title="Audit log" description="Append-only platform activity." />
      <Input placeholder="Filter by action, actor, target…" value={q} onChange={(e) => setQ(e.target.value)} className="mb-4 max-w-sm" />
      <div className="overflow-hidden rounded-xl bg-card ring-1 ring-border">
        <table className="w-full text-left text-sm">
          <thead className="border-b border-border bg-surface-muted/50">
            <tr className="text-[11px] uppercase tracking-wider text-muted-foreground">
              <th className="px-4 py-3 font-medium">When</th>
              <th className="px-4 py-3 font-medium">Actor</th>
              <th className="px-4 py-3 font-medium">Action</th>
              <th className="px-4 py-3 font-medium">Target</th>
              <th className="px-4 py-3 font-medium">Org</th>
              <th className="px-4 py-3 font-medium">IP</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {filtered.slice(0, 60).map((e) => {
              const org = organizations.find((o) => o.id === e.orgId);
              return (
                <tr key={e.id}>
                  <td className="px-4 py-3 font-mono text-[11px] text-muted-foreground">{new Date(e.at).toLocaleString()}</td>
                  <td className="px-4 py-3 font-mono text-[11px]">{e.actor}</td>
                  <td className="px-4 py-3 font-mono text-[11px] font-medium">{e.action}</td>
                  <td className="px-4 py-3 text-muted-foreground">{e.target}</td>
                  <td className="px-4 py-3 text-muted-foreground">{org?.name ?? "—"}</td>
                  <td className="px-4 py-3 font-mono text-[10px] text-muted-foreground">{e.ip}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
